/* NUBO · Página de colección (sección nubo-catalog) · sin dependencias.
   Barra fija de ayuda, aviso de la tabla que se desliza y eventos para medir (Shopify.analytics.publish). */
(function () {
  'use strict';
  if (window.__nuboCatalog) return;
  window.__nuboCatalog = true;

  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('nubo_col_' + name, data || {});
      }
    } catch (e) { /* medir nunca debe romper la página */ }
  }

  function init(root) {
    if (!root || root.__nbcInit) return;
    root.__nbcInit = true;
    var col = root.getAttribute('data-collection') || '';

    /* ---------- Barra fija: aparece al pasar la primera pantalla ---------- */
    var bar = root.querySelector('[data-nbc-bar]');
    var hero = root.querySelector('.nbc-hero');
    if (bar && hero && 'IntersectionObserver' in window) {
      var heroVisible = true, footVisible = false, ctaVisible = false;
      var setBar = function () {
        var on = !heroVisible && !footVisible && !ctaVisible;
        if (bar.classList.contains('is-on') === on) return;
        bar.classList.toggle('is-on', on);
        if (on) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
        else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { heroVisible = e.isIntersecting || e.boundingClientRect.top > 0; });
        setBar();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(hero);
      var cta = document.querySelector('.nb-cta__box');
      if (cta) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { ctaVisible = e.isIntersecting; }); setBar(); }, { rootMargin: '0px 0px -80px 0px' }).observe(cta);
      }
      var foot = document.querySelector('footer.footer, .footer, footer');
      if (foot) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { footVisible = e.isIntersecting; }); setBar(); }).observe(foot);
      }
    }

    /* ---------- Fotos que cargan al bajar: aparecen suavemente en vez de saltar ---------- */
    root.classList.add('nbc-js');
    [].forEach.call(root.querySelectorAll('.nbc-card__img[loading="lazy"]'), function (img) {
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth) done();
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });

    /* ---------- Segunda foto (reclinado) ----------
       Se descarga solo cuando hace falta: en computador cuando el navegador queda libre (o al pasar el mouse);
       en el celular al tocar «Ver reclinado». La foto cambia recién cuando terminó de cargar. */
    var cards = [].slice.call(root.querySelectorAll('[data-nbc-card].has-alt'));
    var settle = function (card, ok) {
      var b = card.querySelector('[data-nbc-flip]');
      if (ok) card.classList.add('alt-ready');
      if (!b) return;
      b.classList.remove('is-loading');
      if (!ok) { b.setAttribute('aria-pressed', 'false'); return; }
      if (b.getAttribute('aria-pressed') === 'true') card.classList.add('is-alt');
    };
    var loadAlt = function (card) {
      var im = card.querySelector('.nbc-card__img--hover');
      if (!im || !im.getAttribute('data-srcset')) return;
      var onload = function () {
        if (!im.currentSrc || im.currentSrc.indexOf('data:') === 0) return; /* todavía es el píxel transparente */
        im.removeEventListener('load', onload);
        settle(card, true);
      };
      im.addEventListener('load', onload);
      im.addEventListener('error', function () { settle(card, false); }, { once: true });
      im.sizes = im.getAttribute('data-sizes') || '100vw';
      im.srcset = im.getAttribute('data-srcset');
      im.removeAttribute('data-srcset');
    };
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
      var preload = function () { idle(function () { cards.forEach(loadAlt); }); };
      if (document.readyState === 'complete') preload(); else window.addEventListener('load', preload, { once: true });
      cards.forEach(function (card) { card.addEventListener('pointerenter', function () { loadAlt(card); }, { once: true }); });
    }
    root.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('[data-nbc-flip]');
      if (b) loadAlt(b.closest('[data-nbc-card]'));
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nbc-flip]');
      if (!b || !root.contains(b)) return;
      e.preventDefault();
      var card = b.closest('[data-nbc-card]');
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!on) { card.classList.remove('is-alt'); return; }
      if (card.classList.contains('alt-ready')) card.classList.add('is-alt');
      else { b.classList.add('is-loading'); loadAlt(card); }
      publish('flip', { collection: col, model: card.getAttribute('data-model') });
    });

    /* ---------- Tabla: borde que se desvanece mientras quede contenido y aviso «Desliza» solo si no cabe ---------- */
    var wrap = root.querySelector('[data-nbc-table]');
    if (wrap) {
      var frame = wrap.closest('[data-nbc-frame]') || wrap;
      var hint = root.querySelector('.nbc-compare__hint');
      var moved = false;
      var edges = function () {
        var max = wrap.scrollWidth - wrap.clientWidth;
        frame.classList.toggle('is-scrollable', max > 4);
        frame.classList.toggle('at-start', wrap.scrollLeft <= 4);
        frame.classList.toggle('at-end', wrap.scrollLeft >= max - 4);
        /* Se apaga con opacidad (sin mover la tabla) cuando la persona ya deslizó */
        if (hint) { hint.classList.toggle('is-on', max > 4); hint.classList.toggle('is-done', moved); }
      };
      wrap.addEventListener('scroll', function () {
        if (!moved && wrap.scrollLeft > 24) { moved = true; publish('compare_scroll', { collection: col }); }
        edges();
      }, { passive: true });
      window.addEventListener('resize', edges);
      edges();
      /* Las letras definitivas pueden cambiar el ancho de la tabla: se vuelve a medir cuando cargan */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(edges);
    }

    /* ---------- Medición de clics ---------- */
    root.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-nbc-track]');
      if (!el || !root.contains(el)) return;
      var card = el.closest('[data-nbc-card]');
      publish(el.getAttribute('data-nbc-track'), {
        collection: col,
        model: card ? card.getAttribute('data-model') : (el.textContent || '').trim().slice(0, 60),
        to: el.getAttribute('data-nbc-to') || undefined
      });
    });
  }

  function boot() { document.querySelectorAll('[data-nbc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-nbc]');
    if (r) { r.__nbcInit = false; init(r); }
  });
})();
